import React, { useLayoutEffect, useRef } from "react";
import { Popover, usePopoverState } from "reakit/Popover";
import styled from "styled-components";
import { GlossyThemeProvider, ZIndexes, prettyScrollbars } from "@glossy";
import { Elevation } from "@glossy/elevations";
import { background, border } from "@glossy/theme";

interface IProps {
  popover: ReturnType<typeof usePopoverState>;
  children: React.ReactNode;
  ariaLabel?: string;
  focusRef?: React.RefObject<HTMLElement>;
}

const MenuWrapper = styled.div`
  & > div:first-child {
    border: 1px solid;
    border-radius: 8px;
  }
`;

const Menu = styled(Popover)`
  background-color: ${background};
  z-index: ${ZIndexes.Menus};
  box-shadow: ${Elevation.Elevation_3};
  border-color: ${border} !important;
  overflow: auto;
  ${prettyScrollbars};
`;

const useMaxPopoverHeight = () => {
  const menuRef = useRef(null);

  useLayoutEffect(() => {
    if (menuRef?.current) {
      const windowHeight = window.innerHeight;
      const clientRect = menuRef.current.getBoundingClientRect();
      // 24 is the bottom spacing
      menuRef.current.style.maxHeight =
        windowHeight - clientRect.top - 72 + "px";
    }
  });

  return menuRef;
};

const UiKitPopover = ({
  children,
  popover,
  ariaLabel = "popover",
  focusRef,
}: IProps) => {
  const menuRef = useMaxPopoverHeight();

  return (
    <MenuWrapper>
      <GlossyThemeProvider name="surface">
        <Menu
          {...popover}
          aria-label={ariaLabel}
          tabIndex={0}
          unstable_finalFocusRef={focusRef}
          ref={menuRef}
        >
          {children}
        </Menu>
      </GlossyThemeProvider>
    </MenuWrapper>
  );
};

export default UiKitPopover;
